import { css } from 'lit';

export const Q1MdTextareaStyles = css`

  :host {
    display: block;
    position: relative;

    --label-width: 4rem;
  }

  :host([required]) label::after {
    content: var(--sl-input-required-content);
    margin-inline-start: var(--sl-input-required-content-offset);
    color: var(--sl-input-required-content-color);
    box-sizing: inherit;
    font-size: var(--sl-input-label-font-size-medium);
    margin-left: 0.2rem;
  }

  label#input-label {
    position: absolute;
    top: 1rem;
    left: 0;
  }

  sl-tab-panel {
    --padding: 0;
  }

  sl-tab-group {
    --track-color: transparent;
  }
  sl-tab-group::part(nav) {
    padding-left: calc(var(--label-width) + 1rem);
  }

  q1-markdown {
    min-height: calc(1.4rem * var(--rows, 4));

    border-radius: var(--sl-input-border-radius-medium);
    font-size: var(--sl-input-font-size-medium);
    background-color: var(--sl-input-background-color);
    border: solid var(--sl-input-border-width) var(--sl-input-border-color);
    padding: 1rem;
  }

`;
